import Loading from '../components/ui/Loading';
import useLanguageDir from '../utils/Hooks/useLanguageDir';
import Footer from './Footer';
import Navbar from './Navbar';
import NavWithSearch from './NavWithSearch';

const Layout = ({
    showWhiteNavbar,
    ShowdetailsNav,
    showAccountNav,
    showInterestNav,
    headerText,
    SearchBar,
    children,
    isLoading = false,
    setIsFooterVisible,
    setActiveNavClick,
    newCarFlag = false
}: any) => {
    const { language_dir } = useLanguageDir();

    const handleScroll = (n: boolean) => {
        if (setIsFooterVisible) {
            setIsFooterVisible(n);
        }
    };

    return (
        <div dir={language_dir}>
            {SearchBar ? (
                <NavWithSearch />
            ) : (
                <Navbar
                    whiteBackground={showWhiteNavbar}
                    ShowdetailsNav={ShowdetailsNav}
                    showAccountNav={showAccountNav}
                    showInterestNav={showInterestNav}
                    headerText={headerText}
                    setActiveNavClick={setActiveNavClick}
                    newCarFlag={newCarFlag}
                />
            )}

            <main>
                {' '}
                {isLoading ? (
                    <div className="loading-container">
                        <Loading />
                    </div>
                ) : (
                    children
                )}
            </main>

            <Footer setIsFooterVisible={handleScroll} />
        </div>
    );
};

export default Layout;
